import React from 'react';

export const emptyObj = {};
export const emptyArr = [];
export const noop = () => {};
export const EmptyComponent = React.forwardRef((props, ref) => {
  return <span ref={ref}></span>;
});
